
























































import { mapGetters } from 'vuex';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LayerSelector extends Vue {
    get layers() {
        return this.$store.state.layers;
    }

    get basemaps() {
        return this.$store.state.basemaps;
    }

    get map() {
        return this.$store.state.map;
    }

    get mapView() {
        return this.$store.state.mapView;
    }

    public mounted() {
        console.log('LayerSelector: mounted()');
    }

    public beforeDestroy() {
        console.log('LayerSelector: destroying()');
    }

    public onBasemapSelect(basemap: string) {
        console.log('LayerSelector:onBasemapSelect');
        this.$store.dispatch('setBasemap', basemap);
    }

    public onLayerToggle(layer: any) {
        console.log('LayerSelector:onLayerToggle');
        this.$store.dispatch('toggleLayer', layer);
    }
}

